export default "__VITE_ASSET__08BlfCnJ__"